module.exports = __webpack_public_path__ + "static/media/logo.4a8ed997.png";